import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Line from "./Line";
import React from "react";
import {selectTags} from "../../redux/selectors/firebase";
import {connect} from "react-redux";
import {Tags} from "../graph/StateTags";

const useScriptStyles = makeStyles(theme => ({
    choice: {
        fontFamily: 'inherit'
    },
    choices: {

    },
}));

interface Props {
    choice: string
    onChoice: (state: string, choice: string) => any
    script: string
    state: string
    tags: Tags
    triggers: string[]
}
function State({choice, onChoice, script, state, tags, triggers}: Props) {
    const classes = useScriptStyles();

    const handleChoiceChange = ({target}: React.ChangeEvent<HTMLInputElement>) => {
        onChoice(state, target.value);
    };
    const choices = triggers.length > 1 &&
        <RadioGroup className={classes.choices} value={choice} onChange={handleChoiceChange}>
            {triggers.map((trigger, index) => (
                <FormControlLabel
                    classes={{label: classes.choice}} key={`${trigger}-${index}`} control={<Radio/>}
                    label={trigger} value={trigger}/>
            ))}
        </RadioGroup>;

    return (<Line id={state} script={script} tags={Object.values(tags[state] || {})}>{choices}</Line>);
}
const mapStateToProps = (store: never) => ({
    tags: selectTags(store) || {},
});
export default connect(mapStateToProps, {
})(State);
